'use client';
import CircularProgress from '@mui/material/CircularProgress';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useState, useEffect, useRef } from 'react';

import { getCpPornAlbumList } from '@/api/couple/cpInfo';
import { getCpPornAlbumVideoList, getCpPornAlbumInfo } from '@/api/couple/cpInfo';
import CpAlbumCard from '@/components/cp/cpAlbumCard/cpAlbumCard';
import { InfiniteScroll } from '@/components/infiniteScroll/infiniteScroll';
import { slickOption } from '@/components/slick/slick';
import { CpPornAlbumList, CpPornAlbumInfo, CpPornAlbumVideoList, DetailInfo } from '@/types/cpType';

import AlbumVideoList from './albumVideoList';

import CpNoData from '../../components/cpNoData/cpNoData';

import style from './albumPage.module.scss';

function AlbumPage({
    userId,
    albumList,
    setAlbumList,
    switchDetail
}: {
    userId: string;
    albumList: CpPornAlbumList[];
    setAlbumList: (imageList: CpPornAlbumList[]) => void;
    switchDetail: (params: DetailInfo) => void;
}) {
    const [albumInfoData, setAlbumInfoData] = useState<CpPornAlbumInfo>({} as CpPornAlbumInfo);
    const [albumVideoListData, setAlbumVideoListData] = useState<CpPornAlbumVideoList[]>([]);
    const [albumInfoOpen, setAlbumInfoOpen] = useState(false);
    const [secondRender, setSecondRender] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const page = useRef(1);
    const isLoading = useRef(false);

    const handleClickAlbum = async (albumId: string) => {
        const listRes = await getCpPornAlbumVideoList({
            userId,
            albumId,
            page: 1,
            limit: 6
        });

        setAlbumVideoListData(listRes.status === 200 ? listRes.data : []);
        const infoRes = await getCpPornAlbumInfo({
            userId,
            albumId
        });

        setAlbumInfoData(infoRes.status === 200 ? infoRes.data : ({} as CpPornAlbumInfo));
        setAlbumInfoOpen(true);
    };

    useEffect(() => {
        setSecondRender(true);
    }, []);

    const handleloadMore = async () => {
        if (!secondRender || isLoading.current) return;

        isLoading.current = true;
        page.current += 1;
        const res = await getCpPornAlbumList({ userId, page: page.current, limit: 12 });
        if (res.status === 200 && res.data.length > 0) {
            setAlbumList([...albumList, ...res.data]);
        } else {
            setIsEnd(true);
        }
        slickOption?.cpInfoResetHeight();
        isLoading.current = false;
    };

    useEffect(() => {
        slickOption?.cpInfoResetHeight();
    }, [albumList]);

    return (
        <>
            {albumList.length > 0 ? (
                <div className={style.albumPage}>
                    <div className={style.albumList}>
                        {albumList.map((album, index) => (
                            <CpAlbumCard
                                album={album}
                                key={`${album.id}_${index}`}
                                onClick={() => handleClickAlbum(album.id)}
                            />
                        ))}
                    </div>
                    {isEnd ? (
                        <div className={style.listEnd}>{albumList.length > 0 && '已經到底嘍…'}</div>
                    ) : (
                        <InfiniteScroll onVisible={handleloadMore}>
                            <div className={style.loadMore}>
                                <CircularProgress size={24} sx={{ color: '#e52027' }} />
                            </div>
                        </InfiniteScroll>
                    )}
                </div>
            ) : (
                <CpNoData />
            )}
            <SwipeableDrawer
                anchor={'bottom'}
                open={albumInfoOpen}
                onClose={() => setAlbumInfoOpen(false)}
                onOpen={() => setAlbumInfoOpen(true)}
                disableSwipeToOpen
            >
                <AlbumVideoList
                    infoData={albumInfoData}
                    listData={albumVideoListData}
                    setListData={setAlbumVideoListData}
                    onClose={() => setAlbumInfoOpen(false)}
                    switchDetail={switchDetail}
                    key={albumInfoData.id}
                />
            </SwipeableDrawer>
        </>
    );
}

export default AlbumPage;
